// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__MzGL4","title":"Images45_title__3Q334","images":"Images45_images__2e9YR"};